import React from 'react'
import { routesDef } from '../../config/routes'
import { useMutation } from '@ztechapps/common.hook'
import { Field, Form, FormSaveButton } from '@ztechapps/webui.form'
import { createDefault } from '@ztechapps/customer.common'
import set from 'lodash/set'
import { isValidEmail } from '@ztechapps/common.utils'
import type { PartialDeep } from 'type-fest'
import type { User } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'
import { Alert, HorizontalStack } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import { TextInput } from '@ztechapps/webui.input'
import { CompanySelect } from '@ztechapps/company.webui'
import { queries } from '../../components/AddCustomer/graphql'

export const AddNewCustomerForm = ({ onSuccessSubmit }: { onSuccessSubmit: (route: string) => void }) => {
  const [onAdd] = useMutation({ ...queries.createConfig })
  const customerDefault = createDefault()
  const initialValues = {
    ...customerDefault,
    code: '',
    company: { value: '', label: '' },
  }

  const validate = (values) => {
    const errors: any = {}
    if (!values.profile?.email) {
      set(errors, 'profile.email', 'Required')
    } else {
      if (!isValidEmail(values.profile?.email)) {
        set(errors, 'profile.email', 'Email is not valid.')
      }
    }
    if (!values.profile?.name) {
      set(errors, 'profile.name', 'Required')
    }

    return errors
  }

  const onSubmit = async ({ code, profile, company }) => {
    const input = {
      code,
      profile,
      services: {
        basic: {
          accessToken: '-unknown-',
          picture: 'https://res.cloudinary.com/tmmshauler/image/upload/v1506318907/hauler/dft-customer.jpg',
          email: profile?.email,
          name: profile?.name,
          password: '-unknown',
          username: profile?.email,
        },
      },
    } as unknown as PartialDeep<User> & { companyName?: string; skipDomain?: boolean }

    if (!isEmpty(company?.value))
      if (company?.__isCreate) {
        input.companyName = company?.value
        input.skipDomain = true
      } else {
        input.company = { _id: company?._id }
      }

    const { data, errors } = await onAdd({ input })
    if (errors) throw errors

    // if then navigate to necessary field is no error then navigate to
    const route = routesDef.CustomerItemPage.altPath({
      _id: data?.createCustomer?._id,
    })

    onSuccessSubmit(route)
  }
  return (
    <Form {...{ initialValues, validate, onSubmit }}>
      <Alert type="info">
        <h4>This will add a new contact information of company.</h4>
        <div>
          If the company exists, it will add the contact information to that company, else it will create the company
          first then add the contact information.
          <br />
          We automatically determine if the company exists using the domain part of provided email address.
        </div>
      </Alert>

      <Stack gap={2}>
        <Field
          name="profile.name"
          component={TextInput}
          label="Full Name"
          initialValues={initialValues}
          help="Full name of the user"
          placeholder="e.g. John Doe"
        />
        <Field
          name="profile.email"
          component={TextInput}
          label="Email"
          initialValues={initialValues}
          help="A unique email address of the customer"
          placeholder="e.g. john@email.com"
        />
        <Field
          name="company"
          component={CompanySelect}
          label="Company Name"
          initialValues={initialValues}
          help="The company name of the customer. If not specified, it will be derived from the email address domain."
          onChange
        />
      </Stack>
      <HorizontalStack className={'justify-content-end mt-3'}>
        <FormSaveButton text="Create" />
      </HorizontalStack>
    </Form>
  )
}
